<div class="container">
  <div class="vertical-line"></div>
  <div class="form-container">
    <!-- Box with header -->
    <div class="box">
      <div class="box-body">
        <div class="change-password-container">
          <!-- Header for Reset Password -->
          <div class="header">
            <h3>Reset Password</h3>
          </div>

          <form (ngSubmit)="onSubmit(passwordForm)" #passwordForm="ngForm">
            <!-- New Password -->
            <mat-form-field appearance="outline">
              <mat-label>New Password</mat-label>
              <input
                matInput
                [type]="showNewPassword ? 'text' : 'password'"
                required
                name="newPassword"
                [(ngModel)]="newPassword"
              />
              <i
                class="eye-icon"
                (click)="toggleNewPasswordVisibility()"
                [ngClass]="showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"
              ></i>
            </mat-form-field>

            <!-- Confirm New Password -->
            <mat-form-field appearance="outline">
              <mat-label>Confirm New Password</mat-label>
              <input
                matInput
                [type]="showConfirmPassword ? 'text' : 'password'"
                required
                name="confirmNewPassword"
                [(ngModel)]="confirmNewPassword"
              />
              <i
                class="eye-icon"
                (click)="toggleConfirmPasswordVisibility()"
                [ngClass]="showConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"
              ></i>
            </mat-form-field>

            <!-- Submit Button -->
            <button
              mat-raised-button
              color="primary"
              type="submit"
              [disabled]="passwordForm.invalid"
            >
              Reset
            </button>
          </form>

          <!-- Loading Indicator -->
          <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

          <!-- Success/Error Message -->
          <div *ngIf="message" [ngClass]="{ success: isSuccess, error: !isSuccess }">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
